import { OFFER_TYPE_ALWAYS_ON } from 'constants/offer'

export default function getLPCRegionLOS(offer: App.Offer | App.OfferSummary | App.BundledOffer): number | null {
  if (offer.type === OFFER_TYPE_ALWAYS_ON && offer.shouldDisplayValue && !offer.isPartnerProperty && offer.property) {
    return offer.property.currentRegionMarketedLos
  }
  return null
}
